import { Compass, PenTool, Smartphone, Gauge } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";

const Cell = ({ icon: Icon, title, text, className = "", children, i }) => (
  <Reveal delay={i * 0.08} className={`group relative overflow-hidden rounded-[6px] bg-[#111111] p-7 sm:p-9 flex flex-col ${className}`}>
    <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-700 bg-[radial-gradient(circle_at_80%_0%,rgba(212,175,90,0.12),transparent_55%)]" />
    <Icon size={22} className="text-gold relative" strokeWidth={1.4} />
    <div className="relative flex-1">{children}</div>
    <h3 className="relative mt-8 font-display text-2xl sm:text-3xl font-semibold tracking-[-0.02em]">{title}</h3>
    <p className="relative mt-3 text-[#A7A7AD] leading-relaxed text-[15px] max-w-md">{text}</p>
  </Reveal>
);

export const Differentials = () => (
  <section id="diferenciais" data-testid="differentials-section" className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12 py-24 lg:py-40">
    <SectionHead index="03" label="Diferenciais" title={<>Design com <span className="font-serif italic font-normal text-gold">propósito</span>, não decoração.</>} />
    <div className="grid gap-4 lg:grid-cols-3 lg:grid-rows-[minmax(300px,auto)_minmax(300px,auto)]">
      <Cell i={0} icon={Compass} title="Estratégia antes do layout" text="Entendemos seu público, seus objetivos e o que diferencia sua empresa. Cada seção do site existe para conduzir o visitante ao próximo passo." className="lg:col-span-2">
        <p className="mt-10 font-serif italic text-3xl sm:text-5xl text-[#F5F3EE]/90 leading-tight max-w-xl">“Quem é você, para quem fala e o que o visitante deve fazer.”</p>
      </Cell>
      <Cell i={1} icon={PenTool} title="Design autoral" text="Nada de temas prontos. Tipografia, composição e ritmo visual são desenhados para a sua marca." className="lg:row-span-2">
        <div className="mt-10 flex items-end gap-3 h-full min-h-[160px]">
          <span className="font-display text-[7rem] sm:text-[9rem] leading-[0.8] font-bold text-[#F5F3EE]">A</span>
          <span className="font-serif italic text-[7rem] sm:text-[9rem] leading-[0.8] text-gold">a</span>
        </div>
      </Cell>
      <Cell i={2} icon={Smartphone} title="Responsivo de verdade" text="Composições pensadas para o celular — não uma versão encolhida do desktop." />
      <Cell i={3} icon={Gauge} title="Desempenho" text="Imagens otimizadas, carregamento progressivo e código enxuto para que o site abra rápido, mesmo em aparelhos modestos." />
    </div>
  </section>
);
